/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bind-project-table.vue?vue&type=template&id=2ed71f83&"
import script from "./bind-project-table.vue?vue&type=script&lang=ts&"
export * from "./bind-project-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports